import loadable from '@loadable/component';

const ProductPriceHistory = loadable(() =>
  import(/* webpackChunkName: "price-history" */ './product-price-history')
);

ProductPriceHistory.variables = ({ id, offset }) => ({
  id: parseInt(id, 10),
  offset: parseInt(offset, 10) || 0,
  statisticsTime: '1970-01-02',
});

ProductPriceHistory.loadOrder = [
  {
    priceHistory: true,
    priceHistoryTable: true,
  },
];

export default ProductPriceHistory;
